export default {
	watch: {
		paginacaoInterna: {
			handler(novoValor) {
				this.$emit('paginar', novoValor)
			},
			deep: true,
		},
	},
	props: {
		paginacao: {
			type: Object,
			required: false,
		},
		totalItens: {
			type: Number,
			required: true,
		},
		totalPaginas: {
			type: Number,
			required: true,
		},
	},
	computed: {
		hasItens() {
			return this.totalItens > 0
		},
	},
	methods: {
		atualizarPaginacaoInterna(paginacao, sortByValue, sortDescValue) {
			this.paginacaoInterna.sortBy = paginacao[sortByValue] || []
			this.paginacaoInterna.sortDesc = paginacao[sortDescValue] || []
		},
		tratarEventoAtualizarPaginacaoInterna(paginacao) {
			if (paginacao.sortBy.length === 0) {
				return this.atualizarPaginacaoInterna(paginacao, 'sortByDefault', 'sortDescDefault')
			}

			return this.atualizarPaginacaoInterna(paginacao, 'sortBy', 'sortDesc')
		},
	},
}
